exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".booking-slide[data-v-4615862a] {\n  --bg-opacity: 1;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, var(--bg-opacity));\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n  padding-top: 3.5rem;\n  padding-bottom: 3.5rem;\n}\n@media (min-width: 640px) {.booking-slide[data-v-4615862a] {\n    padding-left: 3rem;\n\n    padding-right: 3rem;\n\n    padding-top: 4rem;\n\n    padding-bottom: 3.5rem;\n\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n\n    max-width: 28rem;\n\n    margin-left: auto;\n\n    margin-right: auto;\n\n    border-radius: 0.375rem\n}\n}\n", ""]);

// exports
